/* eslint-disable */
import {isNotQualified} from '@aoflmkt/is-webp-qualified';

const imageConfig = {
  logoTopMobile: [{src: `${isNotQualified ? '/assets/routes/home/logo-top-mb-v1.png' : '/assets/routes/home/logo-top-mb-v1.webp'}`}],
  ribbonMenu: [{src: `${isNotQualified ? '/assets/routes/home/ribbon-menu-v1.png' : '/assets/routes/home/ribbon-menu-v1.webp'}`}],
  scrolledHeaderMobile: [{src: `${isNotQualified ? '/assets/routes/home/scrolled-header-mb-v2.png' : '/assets/routes/home/scrolled-header-mb-v2.webp'}`}],
  scrolledHeader: [{src: `${isNotQualified ? '/assets/routes/home/scrolled-header-dt-v1.png' : '/assets/routes/home/scrolled-header-dt-v1.webp'}`}],
  emblem: [{src: `${isNotQualified ? '/assets/routes/home/AA-emblem-v1.png' : '/assets/routes/home/AA-emblem-v1.webp'}`}],
  menuLogo: [
    {maxWidth: 320, src: `${isNotQualified ? '/assets/routes/home/logo-menu-mb-v1-1x.png' : '/assets/routes/home/logo-menu-mb-v1-1x.webp'}`},
    {maxWidth: 480, src: `${isNotQualified ? '/assets/routes/home/logo-menu-mb-v1-2x.png' : '/assets/routes/home/logo-menu-mb-v1-2x.webp'}`},
    {maxWidth: 576, src: `${isNotQualified ? '/assets/routes/home/logo-menu-mb-v1-3x.png' : '/assets/routes/home/logo-menu-mb-v1-3x.webp'}`},
    {maxWidth: 768, src: `${isNotQualified ? '/assets/routes/home/logo-menu-mb-v1-4x.png' : '/assets/routes/home/logo-menu-mb-v1-4x.webp'}`}
  ]
};

export {
  imageConfig
};
